export default {
  // Messages that correspond to each route 'meta.home'
  route: {
    home: 'Accueil',
    entities: 'Organisations',
    properties: 'Installations',
    logbook: 'Journal de bord',
    contracts: 'Contrats',
    actionplans: "Plans d'actions",
    actions: 'Actions',
    requests: 'Interventions',
    alerts: 'Alertes Hypervision',
    dashboard: 'Ancien TDB (BLC)',
    dashboardDispatcher: 'Tableau de bord Dispatcheur',
    dashboardPem: 'Tableau de bord PEM',
    regulatoryControl: 'Contrôles Réglementaires',
  },

  // Global messages
  message: {
    search: 'Recherche',
  },
};
